import { useState, useEffect } from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import React from 'react';
import './slider.scss'

const Slider = (props) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  var slides = props.slideData;

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  return (
    <div className="hero-slider">
      <div className="slider-container">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`slide ${index === currentSlide ? 'active' : ''}`}
          >
            <div className="image-wrapper">
              <img
                src={slide.image}
                alt={slide.title}
                className="slide-image"
              />
            </div>
         
            <div className="content-overlay">
              <div className="overlay-gradient"></div>
             
             
              <div className="content-wrapper">
                <div className="text-container">
                <h1 className="slide-title">{slide.title}</h1>
                <p className="slide-description">{slide.description}</p> 
                </div>                
              </div>
             
              
            </div>
          </div>
        ))}
      </div>

      <button onClick={prevSlide} className="nav-button prev">
        <ArrowLeft className="arrow-icon" />
      </button>
      <button onClick={nextSlide} className="nav-button next">
        <ArrowRight className="arrow-icon" />
      </button>

      <div className="slide-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`indicator ${index === currentSlide ? 'active' : ''}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Slider;